// module imports

document.addEventListener("DOMContentLoaded", function () {
  // Header Scroll Behavior
  let lastScrollTop = 0;
  const header = document.querySelector("header");
  const scrollThreshold = 10;

  window.addEventListener("scroll", function () {
    // Wenn Mobile-Menü offen ist, kein Scroll-Verhalten
    const mobileMenuOpen = document.body.classList.contains("overflow-hidden");
    if (mobileMenuOpen) {
      return;
    }

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= 0) {
      header.classList.remove("header-hidden");
      header.classList.add("header-visible");
      return;
    }

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      header.classList.add("header-hidden");
      header.classList.remove("header-visible");
    } else if (scrollTop < lastScrollTop - scrollThreshold) {
      header.classList.remove("header-hidden");
      header.classList.add("header-visible");
    }

    lastScrollTop = scrollTop;
  });

  // Menu Toggle Code
  const menuToggles = document.querySelectorAll(".menu-toggle");

  menuToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();

      const parentLi = this.closest("li");
      const submenu = parentLi.querySelector(".sub-menu");
      const arrow = this.querySelector(".arrow");

      // Schliesse alle anderen Menüs
      document.querySelectorAll(".sub-menu").forEach((menu) => {
        if (menu !== submenu) {
          menu.classList.add("hidden");
          menu.classList.remove("flex");

          const closedToggle = menu.closest("li").querySelector(".menu-toggle");
          const closedArrow = menu.closest("li").querySelector(".arrow");
          if (closedToggle) {
            closedToggle.classList.remove("menu-active");
          }
          if (closedArrow) {
            closedArrow.classList.remove("rotate-180");
          }
        }
      });

      // Toggle aktuelles Menü
      if (submenu) {
        submenu.classList.toggle("hidden");
        submenu.classList.toggle("flex");
        arrow.classList.toggle("rotate-180");
        this.classList.toggle("menu-active");

        // Standard-Bild beim Öffnen anzeigen
        if (submenu.classList.contains("flex")) {
          const defaultImage = submenu.getAttribute("data-default-image");
          const imageElement = submenu.querySelector(".menu-hover-image");

          if (defaultImage && imageElement) {
            imageElement.src = defaultImage;
            imageElement.classList.remove("opacity-0");
            imageElement.classList.add("opacity-100");
          }
        }
      }
    });
  });

  // Initialize Intersection Observer for slideup elements
  const slideUpElements = document.querySelectorAll(".slideup");
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("slideup-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
    },
  );

  slideUpElements.forEach((element) => {
    observer.observe(element);
  });

  // Hover-Effekt für Bilder
  const menuSubItems = document.querySelectorAll(".menu-sub-item");

  menuSubItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      const hoverImage = this.getAttribute("data-hover-image");
      const submenu = this.closest(".sub-menu");
      const imageElement = submenu.querySelector(".menu-hover-image");
      const defaultImage = submenu.getAttribute("data-default-image");

      if (hoverImage && imageElement) {
        imageElement.src = hoverImage;
        imageElement.classList.remove("opacity-0");
        imageElement.classList.add("opacity-100");
      } else if (defaultImage && imageElement) {
        imageElement.src = defaultImage;
        imageElement.classList.remove("opacity-0");
        imageElement.classList.add("opacity-100");
      }
    });

    item.addEventListener("mouseleave", function () {
      const submenu = this.closest(".sub-menu");
      const imageElement = submenu.querySelector(".menu-hover-image");
      const defaultImage = submenu.getAttribute("data-default-image");

      if (imageElement) {
        if (defaultImage) {
          imageElement.src = defaultImage;
        } else {
          imageElement.classList.remove("opacity-100");
          imageElement.classList.add("opacity-0");
        }
      }
    });
  });

  // Schliessen bei Klick außerhalb
  document.addEventListener("click", function (e) {
    const isMenuToggle = e.target.closest(".menu-toggle");
    const isSubmenu = e.target.closest(".sub-menu");

    if (!isMenuToggle && !isSubmenu) {
      document.querySelectorAll(".sub-menu").forEach((menu) => {
        menu.classList.add("hidden");
        menu.classList.remove("flex");

        const toggle = menu.closest("li").querySelector(".menu-toggle");
        const arrow = menu.closest("li").querySelector(".arrow");
        if (toggle) {
          toggle.classList.remove("menu-active");
        }
        if (arrow) {
          arrow.classList.remove("rotate-180");
        }
      });
    }
  });

  // Close-Button Event Listener
  document.querySelectorAll(".submenu-close").forEach((closeBtn) => {
    closeBtn.addEventListener("click", function () {
      const submenu = this.closest(".sub-menu");
      const parentLi = submenu.closest("li");
      const toggle = parentLi.querySelector(".menu-toggle");
      const arrow = toggle.querySelector(".arrow");

      submenu.classList.add("hidden");
      submenu.classList.remove("flex");
      arrow.classList.remove("rotate-180");
      toggle.classList.remove("menu-active");
    });
  });

  // =====================
  // GALLERY SLIDER
  // =====================
  initGallerySlider();

  // =====================
  // FORM PROGRESS NAVIGATION
  // =====================
  initFormNavigation();

  // Akkordeon
  const akkordeonButtons = document.querySelectorAll(".akkordeon-button");

  akkordeonButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const akkordeonItem = this.parentElement;
      const content = akkordeonItem.querySelector(".akkordeon-content");
      const horizontalLine = this.querySelector(".horizontal-line");
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      // Schließe alle anderen Akkordeons
      akkordeonButtons.forEach((otherButton) => {
        if (otherButton !== this) {
          const otherItem = otherButton.parentElement;
          const otherContent = otherItem.querySelector(".akkordeon-content");
          const otherLine = otherButton.querySelector(".horizontal-line");

          otherContent.style.maxHeight = "0px";
          otherButton.setAttribute("aria-expanded", "false");
          if (otherLine) {
            otherLine.style.opacity = "1";
          }
        }
      });

      // Toggle aktuelles Akkordeon
      if (isExpanded) {
        content.style.maxHeight = "0px";
        this.setAttribute("aria-expanded", "false");
        if (horizontalLine) {
          horizontalLine.style.opacity = "1";
        }
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        this.setAttribute("aria-expanded", "true");
        if (horizontalLine) {
          horizontalLine.style.opacity = "0";
        }
      }
    });
  });
  function initSelectAnrede() {
    const selects = document.querySelectorAll("select.dropdown");

    if (selects.length === 0) {
      // Elemente noch nicht da, nochmal versuchen
      setTimeout(initSelectAnrede, 100);
      return;
    }

    selects.forEach((sel) => {
      function update() {
        if (sel.value === "" || sel.selectedIndex === 0) {
          // Placeholder ist ausgewählt
          sel.classList.remove("has-value");
          sel.classList.add("is-placeholder");
        } else {
          // Eine echte Option ist ausgewählt
          sel.classList.add("has-value");
          sel.classList.remove("is-placeholder");
        }
      }

      // Event Listener hinzufügen
      sel.addEventListener("change", update);

      // Initial ausführen
      update();
    });
  }

  // Starte die Initialisierung
  initSelectAnrede();

  // Externe Links und PDF-Links in neuem Tab öffnen
  document.querySelectorAll("a[href]").forEach((link) => {
    const href = link.getAttribute("href");

    const isPdf = href.toLowerCase().endsWith(".pdf");

    let isExternal = false;
    try {
      const url = new URL(href, window.location.href);
      isExternal = url.hostname !== window.location.hostname;
    } catch (e) {
      // Ungültige URLs überspringen
    }

    if (isPdf || isExternal) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    }
  });

  // VIDEO SLIDER
  initVideoSlider();
});

// Gallery Slider Funktion
function initGallerySlider() {
  const carousel = document.getElementById("image-gallery-carousel");
  const track = document.getElementById("carousel-track");
  const prevBtn = document.getElementById("carousel-prev-btn");
  const nextBtn = document.getElementById("carousel-next-btn");
  const prevBtnMobile = document.getElementById("carousel-prev-btn-mobile");
  const nextBtnMobile = document.getElementById("carousel-next-btn-mobile");

  // Früh aussteigen wenn Elemente nicht existieren
  if (!carousel || !track) {
    return;
  }

  const slides = track.querySelectorAll(".gallery-slide");
  const totalSlides = slides.length;
  let currentSlide = 0;
  let isAnimating = false;

  if (totalSlides === 0) {
    console.warn("Gallery: No slides found");
    return;
  }

  // Initialize carousel
  function initCarousel() {
    carousel.classList.add("loaded");
    updateSlidePosition(false);
    updateButtons();
  }

  // Update slide position with smooth animation
  function updateSlidePosition(animate = true) {
    if (animate) {
      track.classList.add("transitioning");
      isAnimating = true;

      const onTransitionEnd = () => {
        track.classList.remove("transitioning");
        isAnimating = false;
        track.removeEventListener("transitionend", onTransitionEnd);
      };

      track.addEventListener("transitionend", onTransitionEnd, { once: true });

      // Fallback timeout falls transitionend nicht feuert
      setTimeout(() => {
        isAnimating = false;
        track.classList.remove("transitioning");
      }, 500);
    } else {
      track.classList.remove("transitioning");
    }

    const translateX = -currentSlide * 100;
    track.style.transform = `translateX(${translateX}%)`;
  }

  // Go to specific slide
  function goToSlide(index) {
    if (isAnimating || index === currentSlide || index < 0 || index >= totalSlides) return;

    // Laufende Videos pausieren beim Slide-Wechsel
    track.querySelectorAll("video").forEach((video) => {
      if (!video.paused) video.pause();
    });

    currentSlide = index;
    updateSlidePosition(true);
    updateButtons();
  }

  // Go to next slide
  function nextSlide() {
    if (isAnimating) return;
    const next = (currentSlide + 1) % totalSlides;
    goToSlide(next);
  }

  // Go to previous slide
  function prevSlide() {
    if (isAnimating) return;
    const prev = (currentSlide - 1 + totalSlides) % totalSlides;
    goToSlide(prev);
  }

  // Update button states
  function updateButtons() {
    // Buttons sind immer aktiv für infinite loop
  }

  // Event listeners für Desktop Buttons
  if (prevBtn) {
    prevBtn.addEventListener("click", prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", nextSlide);
  }

  // Event listeners für Mobile Buttons
  if (prevBtnMobile) {
    prevBtnMobile.addEventListener("click", prevSlide);
  }

  if (nextBtnMobile) {
    nextBtnMobile.addEventListener("click", nextSlide);
  }

  // Keyboard navigation (nur wenn Carousel im Viewport)
  document.addEventListener("keydown", function (e) {
    if (!carousel.matches(":hover")) return;
    if (e.key === "ArrowLeft") prevSlide();
    if (e.key === "ArrowRight") nextSlide();
  });

  // Touch/Swipe support
  let startX = 0;
  let isDragging = false;

  track.addEventListener(
    "touchstart",
    function (e) {
      if (isAnimating) return;
      startX = e.touches[0].clientX;
      isDragging = true;
    },
    { passive: true },
  );

  track.addEventListener(
    "touchend",
    function (e) {
      if (!isDragging || isAnimating) return;

      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }

      isDragging = false;
    },
    { passive: true },
  );

  // Prevent context menu on long press
  track.addEventListener("contextmenu", (e) => e.preventDefault());

  // Init
  initCarousel();
}

// Form Progress Navigation
function initFormNavigation() {
  // Nur auf Seiten mit #formular ausführen
  const formContainer = document.getElementById("formular");
  if (!formContainer) return;

  // Funktion die die Navigation aufbaut
  function buildNavigation() {
    // Prüfen ob Navigation bereits existiert
    if (document.getElementById("form-progress-nav")) return;

    // Konfiguration: Titel und Labels für die Navigation
    const isEn = document.documentElement.lang.startsWith("en");
    const isLogistik = !!document.querySelector(".logistikanfrage");
    const navConfig = isLogistik
      ? [
          { className: "lagertyp", label: isEn ? "Storage type" : "Lagertyp" },
          { className: "kontaktangaben", label: isEn ? "Contact details" : "Kontaktangaben" },
          { className: "lagerzeitraum", label: isEn ? "Storage period" : "Lagerzeitraum" },
          { className: "ware", label: isEn ? "Goods" : "Ware" },
          { className: "upload", label: isEn ? "Upload" : "Upload" },
        ]
      : [
          { className: "transporttyp", label: isEn ? "Transport type" : "Transporttyp" },
          { className: "kontaktangaben", label: isEn ? "Contact details" : "Kontaktangaben" },
          { className: "absender", label: isEn ? "Sender" : "Absender" },
          { className: "empfanger", label: isEn ? "Recipient" : "Empfänger" },
          { className: "lieferzeitraum", label: isEn ? "Delivery period" : "Lieferzeitraum" },
          { className: "sendung", label: isEn ? "Shipment" : "Sendung" },
          { className: "upload", label: isEn ? "Upload" : "Upload" },
        ];

    // 2. Alle Titel-Felder finden (mit kontakt-titel-feld Klasse)
    const sections = [];
    navConfig.forEach((config) => {
      // Suche nach HTML-Container mit der Klasse
      const section = formContainer.querySelector(`.kontakt-titel-feld.${config.className}`);
      if (section) {
        section.setAttribute("data-section-id", config.className);
        sections.push({
          element: section,
          id: config.className,
        });
      }
    });

    // Nur fortfahren wenn mindestens eine Section gefunden wurde
    if (sections.length === 0) return;

    // 1. Navigation erstellen
    const navHTML = `
      <nav id="form-progress-nav" class="form-progress-nav">
        <ul class="progress-list">
          ${navConfig
            .map(
              (item) => `
            <li class="progress-item" data-section="${item.className}">
              <span class="progress-label w-[124px]">${item.label}</span>
              <span class="progress-dot"></span>
            </li>
          `,
            )
            .join("")}
        </ul>
      </nav>
    `;

    // Navigation ins DOM einfügen
    document.body.insertAdjacentHTML("beforeend", navHTML);

    const formNav = document.getElementById("form-progress-nav");

    // 3. Navigation Items
    const navItems = document.querySelectorAll(".progress-item");

    // 4. Intersection Observer Setup für aktive Section
    const sectionObserverOptions = {
      root: null,
      rootMargin: "-20% 0px -70% 0px",
      threshold: 0,
    };

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.getAttribute("data-section-id");

          navItems.forEach((item) => item.classList.remove("active"));

          const activeNavItem = document.querySelector(
            `.progress-item[data-section="${sectionId}"]`,
          );
          if (activeNavItem) {
            activeNavItem.classList.add("active");
          }
        }
      });
    }, sectionObserverOptions);

    // Observer auf alle Sections anwenden
    sections.forEach((section) => {
      sectionObserver.observe(section.element);
    });

    // 5. Scroll Handler für Sichtbarkeit und Position der Navigation
    function updateNavPosition() {
      const formRect = formContainer.getBoundingClientRect();
      const navHeight = formNav.offsetHeight;
      const viewportHeight = window.innerHeight;
      const navCenterOffset = navHeight / 2;

      // Berechne wann die Navigation sichtbar sein soll
      const formTop = formRect.top;
      const formBottom = formRect.bottom;

      // Navigation einblenden wenn formular Section im Viewport
      if (formTop < viewportHeight && formBottom > 0) {
        formNav.classList.add("visible");

        // Berechne die vertikale Position
        const navTopPosition = viewportHeight / 2 - navCenterOffset;

        // Prüfe ob die Navigation am unteren Rand der Section stoppen muss
        const maxBottomPosition = formBottom - navHeight - 40; // 40px Abstand vom unteren Rand

        if (maxBottomPosition < navTopPosition) {
          // Navigation muss am unteren Rand stoppen
          formNav.style.position = "fixed";
          formNav.style.top = `${maxBottomPosition}px`;
        } else if (formTop > 100) {
          // Formular ist noch nicht weit genug oben - Navigation am oberen Rand des Formulars
          formNav.style.position = "fixed";
          formNav.style.top = `${Math.max(formTop + 100, navTopPosition)}px`;
        } else {
          // Normal zentriert
          formNav.style.position = "fixed";
          formNav.style.top = "50%";
          formNav.style.transform = "translateY(-50%)";
        }
      } else {
        // Navigation ausblenden wenn ausserhalb der Section
        formNav.classList.remove("visible");
      }
    }

    // Initial und bei Scroll ausführen
    updateNavPosition();
    window.addEventListener("scroll", updateNavPosition, { passive: true });
    window.addEventListener("resize", updateNavPosition, { passive: true });

    // 6. Click Handler für Navigation
    navItems.forEach((item) => {
      item.addEventListener("click", function () {
        const targetSectionId = this.getAttribute("data-section");
        const targetSection = formContainer.querySelector(`[data-section-id="${targetSectionId}"]`);

        if (targetSection) {
          const offsetTop = targetSection.getBoundingClientRect().top + window.pageYOffset - 200;
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
        }
      });
    });

    // 7. Erste Section als aktiv markieren
    if (navItems.length > 0) {
      navItems[0].classList.add("active");
    }
  }

  // Ninja Forms lädt dynamisch - wir müssen warten
  // Versuche zuerst direkt
  const firstSection = formContainer.querySelector(".kontakt-titel-feld");
  if (firstSection) {
    buildNavigation();
  } else {
    // MutationObserver um auf Ninja Forms zu warten
    const mutationObserver = new MutationObserver((mutations, obs) => {
      const section = formContainer.querySelector(".kontakt-titel-feld");
      if (section) {
        obs.disconnect(); // Observer stoppen
        buildNavigation();
      }
    });

    mutationObserver.observe(formContainer, {
      childList: true,
      subtree: true,
    });

    // Fallback: Nach 5 Sekunden aufhören zu beobachten
    setTimeout(() => {
      mutationObserver.disconnect();
    }, 5000);
  }
}

// Koordinaten Firmenstandorte
const locationCoordinates = [
  {
    name: "Wil",
    lat: 47.44035557852044,
    lng: 9.055970537434249,
  },
  {
    name: "Schwarzenbach",
    lat: 47.44468968463202,
    lng: 9.072013973970423,
  },
  {
    name: "Bazenheid",
    lat: 47.40855894943209,
    lng: 9.064601347874511,
  },
  {
    name: "Bürglen",
    lat: 47.54359123719525,
    lng: 9.161896959136078,
  },
  {
    name: "Ermatingen",
    lat: 47.66720778380779,
    lng: 9.089709184870163,
  },
  {
    name: "Jonschwil",
    lat: 47.427365211197625,
    lng: 9.08339470773814,
  },
  {
    name: "Konstanz",
    lat: 47.676174051508724,
    lng: 9.159433541926461,
  },
  {
    name: "Kreuzlingen",
    lat: 47.657452365842936,
    lng: 9.159479876652156,
  },
  {
    name: "Schaffhausen",
    lat: 47.71613358889195,
    lng: 8.659850267248572,
  },
  {
    name: "St. Gallen",
    lat: 47.40360588677161,
    lng: 9.293808541420875,
  },
  {
    name: "St. Gallen Luftfracht",
    lat: 47.440032795699565,
    lng: 9.41839416372905,
  },
  {
    name: "Wängi",
    lat: 47.496073181655234,
    lng: 8.953739174555427,
  },
  {
    name: "Wil Agrar",
    lat: 47.460097272317334,
    lng: 9.046190839705678,
  },
];

// VIDEO SLIDER
function initVideoSlider() {
  var sliderEl = document.querySelector(".video-slider-flickity");
  if (!sliderEl) return;

  var fewVideos = sliderEl.dataset.fewVideos === "1";
  var isDesktop = window.innerWidth >= 782;

  // Alle lokalen Videos stoppen und Play-Button zurücksetzen
  function stopAllVideos() {
    sliderEl.querySelectorAll(".video-slider-item").forEach(function (item) {
      var vid = item.querySelector("video");
      if (vid) {
        vid.pause();
        vid.currentTime = 0;
      }
      var iframeSlot = item.querySelector(".vs-iframe-slot");
      if (iframeSlot) {
        iframeSlot.innerHTML = "";
      }
      item.classList.remove("vs-playing");
    });
  }

  // Flickity, Arrow und Dots nur bei > 3 Videos oder Mobile
  if (!(fewVideos && isDesktop)) {
    var flkty = new Flickity(sliderEl, {
      cellAlign: window.innerWidth < 782 ? "center" : "left",
      contain: false,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      draggable: true,
      adaptiveHeight: false,
    });

    // Prev-Button (nur Desktop)
    var prevBtn = document.querySelector(".video-slider-prev");
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        flkty.previous();
      });
    }

    // Custom Dots erstellen
    var dotsWrap = document.querySelector(".video-slider-dots");
    if (dotsWrap) {
      flkty.slides.forEach(function (slide, i) {
        var dot = document.createElement("button");
        dot.setAttribute("aria-label", "Slide " + (i + 1));
        dot.style.cssText =
          "width:10px;height:10px;border-radius:50%;border:none;cursor:pointer;padding:0;transition:opacity .2s;background:#48A32C;";
        dot.style.opacity = i === 0 ? "1" : "0.3";
        dot.addEventListener("click", function () {
          flkty.select(i);
        });
        dotsWrap.appendChild(dot);
      });

      flkty.on("select", function () {
        dotsWrap.querySelectorAll("button").forEach(function (d, i) {
          d.style.opacity = i === flkty.selectedIndex ? "1" : "0.3";
        });
      });
    }

    // Beim Slide-Wechsel laufende Videos stoppen
    flkty.on("change", function () {
      stopAllVideos();
    });
  }

  // Play-Buttons (immer aktiv)
  sliderEl.querySelectorAll(".video-play-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = this.closest(".video-slider-item");
      var video = item.querySelector("video");
      var externWrap = item.querySelector(".video-extern-wrapper");

      if (video) {
        if (video.paused) {
          // Andere Videos stoppen, dann dieses abspielen
          stopAllVideos();
          video.play();
          item.classList.add("vs-playing");
        } else {
          // Pausieren
          video.pause();
          item.classList.remove("vs-playing");
        }
      } else if (externWrap) {
        // Andere Videos stoppen
        stopAllVideos();
        var iframeSlot = externWrap.querySelector(".vs-iframe-slot");
        var embedUrl = externWrap.getAttribute("data-embed");
        var iframe = document.createElement("iframe");
        iframe.src = embedUrl;
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("allow", "autoplay; fullscreen");
        // Scale-Trick: Iframe auf 720px rendern damit YouTube HD-Stream wählt,
        // dann per CSS-Transform auf Container-Größe zurückschrumpfen.
        // Inline-Styles nötig um Reset- und Slider-CSS (width:100%, inset:0) zu überschreiben.
        var containerW = iframeSlot.offsetWidth || 295;
        var containerH = iframeSlot.offsetHeight || Math.round((containerW * 16) / 9);
        var hdWidth = 480;
        var hdHeight = Math.round(containerH * (hdWidth / containerW));
        var scale = containerW / hdWidth;
        iframe.style.position = "absolute";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.right = "auto";
        iframe.style.bottom = "auto";
        iframe.style.width = hdWidth + "px";
        iframe.style.height = hdHeight + "px";
        iframe.style.maxWidth = "none";
        iframe.style.transformOrigin = "top left";
        iframe.style.transform = "scale(" + scale + ")";
        iframeSlot.appendChild(iframe);
        item.classList.add("vs-playing");
      }
    });
  });
}
